import { Injectable } from '@angular/core';
import { ConstantService } from './constant.service';
import { DatePipe } from '@angular/common';
import { UtilService } from './util.service';
import { CommonService } from './common.service';
import { GetFinboxBankSDKURLReq, GetFinboxURLReq, GetVendorURLReq } from '../models/request.model';
import clevertap from 'clevertap-web-sdk';
import { UserSessionService } from './user-session.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { LoaderbotomsheetComponent } from '../components/loaderbotomsheet/loaderbotomsheet.component';

@Injectable({
  providedIn: 'root'
})
export class ModificationCommonService {

  constructor(private constantService : ConstantService, private datePipe : DatePipe , private utilService : UtilService, private commonService : CommonService,private userSessionService: UserSessionService,private _bottomSheet : MatBottomSheet, private matDialog: MatDialog) { }

  async GetFinboxBankSDKURL() {
    const appSource: string | undefined = localStorage.getItem(this.constantService.localStorageElement.appSource) || '';
    const ipAddress: string | undefined = '192.168.0.1'
    const clientCode: string | undefined = localStorage.getItem(
        this.constantService.localStorageElement.clientCode
    ) || '';

    const todayDt = this.datePipe.transform(new Date(), this.constantService.checksumDateFormate);
    const parameter = clientCode + appSource + ipAddress + todayDt;
    const checkSumValue = this.utilService.GenerateCheckSum(appSource, parameter);
    const basicAuth = localStorage.getItem('Authorization');
    const returnUrl =
        window.location.hostname === 'localhost'
            ? 'http://localhost:63555/derivative/loader'
            : 'https://' + window.location.hostname + '/derivative/loader';

          const getFinboxBankSDKURLReq: GetFinboxBankSDKURLReq = {
            head: {
              IPAddress: ipAddress,
              AppSource: appSource,
              ChecksumValue: checkSumValue
            },
            body: {
              clientCode: clientCode,
              businessID: this.constantService.businessID,
              userId: this.utilService.getUserId(clientCode),
              userType: this.utilService.getUserType(),
              return_URL: returnUrl
            }
        };
        this.commonService.GetFinboxBankSDKURL(getFinboxBankSDKURLReq).subscribe({next : (response:any) => {
            // this.clevertapPush('Segment_Activation_MOD', { action: 'MOD_SEG_FINBOX' });
            const resp = JSON.parse(response.data.body.Response);
            window.open(resp.redirect_url, '_self');
        },error:(error)=>{
  
          }})
  }

  async getFinboxURL() {

    const appSource: string  = this.userSessionService.getUserSessionData().appSource;
    const ipAddress: string  = this.userSessionService.getUserSessionData().ip
    const clientCode: string  = this.userSessionService.getUserSessionData().clientCode
   
    const returnUrl =
        window.location.hostname === 'dev'
            ? 'http://dev.5paisa.in:4200/derivative/loader'
            : 'https://' + window.location.hostname + '/derivative/loader';

    const parameter =  appSource + clientCode+ ipAddress + returnUrl +this.utilService.checkSumDate;
          const getFinboxURLReq: GetFinboxURLReq = {
            appSource: appSource,
            ipAddress: ipAddress,
            checkSumValue: this.utilService.GenerateCheckSum(parameter),
            clientCode: clientCode,
            userId: this.utilService.getUserId(clientCode),
            redirectUrl:returnUrl
        };
        this.commonService.getFinboxURL(getFinboxURLReq).subscribe({next : (response:any) => {
            clevertapPush('Segment_Activation_MOD', { action: 'MOD_SEG_FINBOX' });
            window.open(response.data.redirectUrl, '_self');
        },error:(error)=>{
  
          }})
  }


  async getVendorURL() {
        const appSource: string  = this.userSessionService.getUserSessionData().appSource;
    const ipAddress: string  = this.userSessionService.getUserSessionData().ip
    const clientCode: string  = this.userSessionService.getUserSessionData().clientCode
            const returnUrl =
              window.location.hostname.includes('dev') 
                  ? 'http://dev.5paisa.in:4200/derivative/loader'
                  : 'https://' + window.location.hostname + '/derivative/loader';   
                //appSource (In UPPER Case) + clientCode + ipAddress + redirectUrl + vendorType
                const checksum = appSource+  clientCode  + ipAddress + returnUrl + 'FINBOX' + this.utilService.checkSumDate
                sessionStorage.setItem('vendorType','FINBOX')
                const getVendorURLReq: GetVendorURLReq = {
                  appSource:  appSource,
                  ipAddress: this.userSessionService.getUserSessionData().ip,
                  checkSumValue: this.utilService.GenerateCheckSum(checksum),
                  clientCode: this.userSessionService.getUserSessionData().clientCode,
                  redirectUrl: returnUrl,
                  userId: this.userSessionService.getUserSessionData().clientCode,
                  vendorType :  'FINBOX'
                };
          this.commonService.getVendorURL(getVendorURLReq).subscribe({
            next: (response) => {
             sessionStorage.setItem('sessionId', response.data.sessionId);
            this.cardSubmit(response.data.redirectUrl)
              // window.location.href = response.data.redirectUrl;
          },error : (err)=>{
          },})
      }

  async cardSubmit(url:string) {
          const isMobile = window.innerWidth <= 768;
          if (isMobile) {
          // Open as bottom sheet on mobile
          this._bottomSheet.open(LoaderbotomsheetComponent, { 
            disableClose: true,
            data: {
                url:url
              }
          });
          } else {
          // Open as dialog on desktop/web
            this.matDialog.open(LoaderbotomsheetComponent, {
              width: '360px',
              height: '286px',
              panelClass: 'custom-dialog-container',
              disableClose: true,
              data: {
                url:url
              }
            });
          }
        }

    
}

export function clevertapPush(EvnetName : any, property : any) {
  clevertap.event.push(EvnetName, property);
}